module.exports = __webpack_public_path__ + "img/q28.aae33b0a.png";